import React, { Component } from 'react';

import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import './Term.css';
import viewer from './viewer.png';
import superfamily from './superfamily.png';
import pfam from './pfam.png';
import { Stage, ColormakerRegistry } from 'ngl';

import { fetchTerm, fetchSearch } from './staticData';

import Viz from "viz.js";
import { Module, render } from "viz.js/full.render";

import ReactGA from 'react-ga'

import '../config.js';

const restServer = global.restServer;

const isStaticSite = false;

function logEvent (action) {
    console.log('log event:', action);
    ReactGA.event(
        {
            'category': 'User',
            'action': action
        }
    );
}

class Term extends Component {
    constructor(props) {
        super(props);
        const termId =  this.props.match.params.termId;
      
        this.state = {
            data: {},
            termId : termId
        };
    }

    fetchTermInfo(termId) {
        if (isStaticSite) {
            let tdata = fetchTerm(termId);
            tdata.termId = termId;
            this.setState({data: tdata, termId: termId});
        } else {
            const url = [restServer, 'term', termId].join("/");
            fetch(url)
            .then(response => response.json())
            .then(data => { data.termId = termId; this.setState({data: data, termId: termId})});
        }
    }

    componentDidMount() {
        this.fetchTermInfo(this.props.match.params.termId);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.termid !== this.props.match.params.termId) {
            this.fetchTermInfo(nextProps.match.params.termId);
        }
    }

    render() {
        const tdata = this.state.data;
        if (!tdata) {
            return (<></>)
        }

        if (tdata.error) {
            return(
                <div id="term-panel">
                    <div id="termtitle"> {tdata.error}</div>
                </div>
            )
        }

        return (
        <div>
            <TermParents termId={this.state.termId} type={tdata.protein_type} />
            
            <TermInfo tdata={tdata} termId={this.state.termId}/>

            { tdata.children ? tdata.children.map( (ct) => ( <TermChildren key={"k_"+ct.type} children={ct.nodes} type={ct.type} />)) : '' }

            <Domains termId={this.state.termId} rank={tdata.rank} />

            { tdata.sequence ? <Representative termId={this.state.termId} pdb_id={tdata.pdb_id} uniprot_id={tdata.uniprot_id} sequence={tdata.sequence}
                segments={tdata.protein_segments} /> : '' }

            { tdata.pdb_id ? <StructureViewer tdata={tdata} pdb_id={tdata.pdb_id} selectedResidues={tdata.pdb_segments}/> : '' }
        </div>
        )
    }
}

class TermParents extends Component {
    constructor(props) {
        super(props);
   
        this.state = {
            termId: props.termId,
            data: {}
        }
    }
    
    fetchParents = (termId) => {
        const url = [restServer, 'parents', termId].join("/");
        this.setState({termId: termId});
        console.log(' fetch ', url);
        fetch(url)
            .then(response => response.json())
            .then(data =>  this.setState({ data: data, isFetching: false, isInitialised: true, isCollapsed: false }))
            .catch( e=> console.log(e));
    }

    componentDidMount() {
        this.fetchParents(this.state.termId); 
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.termId !== this.props.termId) {
            this.fetchParents(nextProps.termId);
        }
    }

    render() {
        const items = this.state.data.parents || [];
    
        if (! items.length ) {
            return (<></>)
        }

        return (
            <div className="panel-parents">
                <div className="tpcontainer">
                {items.map((item, index) => (
                    <ParentTerm key={"p_"+item.id} termid={item.id} name={item.name} ptype={item.type} ptid={item.pt_id} ptname={item.pt_name}/>
                ))}
                </div>
            </div>
        )
    }
}

function getPDBRegion(item) {
    if (item.pdb_regions) {
        return item.pdb_regions.map( (part) => {
            return part[0]+':'+part[1] + '-' + part[2];
        }).join(',');
    }
    return '';
}

class Domains extends Component {
    constructor(props){
        super(props)

        this.state = {
            isFetching : false,
            isInitialised: false,
            data: []
        }
    }

    fetchDomains = (termId) => {
        this.setState({...this.state, isFetching: true});
        const url = [restServer, 'domains_fast', termId].join("/");
        console.log('fetch doamins', url);
        fetch(url)
        .then(response => response.json())
        .then(data => this.setState({data: data, isFetching: false, isInitialised: true}));
    }

    componentDidMount() {    
        const termId = this.props.termId;
        this.fetchDomains(termId);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.termId !== this.props.termId) {
            const termId =  nextProps.termId;
            this.fetchDomains(termId);
        }
    }
     
    render() {
        if (this.state.isFetching) {
            return(<div> Fetching domains .. </div>)
        }
     
        const items = this.state.data.domains;
        if (! items ) {
            return (<></>)
        }
       
        const inum = items.length;        
        if (! inum ) {
            return (<></>)
        }
        
        return (
            <div id="termdomains" className="panel-children">

                <div className="domain-panel-title">
                    <div className="td-panel-name">
                    Domains <span className="title-note">[ {inum} { inum > 1 ? "entries" : "entry "} ]</span>
                    </div>
                    <div className="th-protein-id">ID</div>
                    <div className="th-protein-region">Region</div>
                    <div className="th-protein-link">Links</div>
                </div>

                {
                    items.map((item, index) => {
                        const iparts = item.protein_regions ? item.protein_regions.map( (part) => { return part[0] + '-' + part[1] }).join(',') : '';
                        const parts = getPDBRegion(item);

                      //  console.log(item.id , parts);
                        
                        return  (<TermDomain key={"d_"+item.id + item.pdb_begin} type={item.type} 
                            name={item.protein_name ? item.protein_name : item.rs_name } 
                            species={item.species ? item.species : item.taxid } 
                            pdbid={item.pdb_id} parts={parts}
                            uniprot={item.uniprot_id} iparts={iparts}
                            represents={item.num} id={item.id} />)
                    })
                }
            </div>
        )
    }
}

class StructureViewer extends Component {
    /* Arguments:
        PDBId : pdb domain id, 
            e.g 2BCG
        selectedResidues : array of the residues to select, 
            e.g [
                { 
                    chain: "A",
                    segments: ["1-10","10-30"]
                }
            ]
    */
    constructor(props) {
        super(props);
        this.state = {
            props: props
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let pdbid = nextProps.pdb_id;
        let selectedResidues = nextProps.selectedResidues;
    
        var stage = this.state.ngl;
        
        let dhash = selectedResidues.reduce( (p, n) => {
            let chain = n[0];
            if (p[chain]) {
                p[chain].push(n[1] + '-' + n[2]);
            } else {
                p[chain] = [n[1] + '-' + n[2]];
            }
            return p;
        }, {});

       
        let selectionScheme = Object.keys(dhash).map( (k) => {
            return [colourMap["domain-scop"],  (':' + k + ' and ('+dhash[k].join(' or ') + ')')];
        });

        Object.keys(dhash).map( (k) => {
            return selectionScheme.push( [colourMap["domain-chain"],  (':' + k)]);
        });
        
        selectionScheme.push( [colourMap["domain-pdb"], "*"] );
       // console.log("SS2:", selectionScheme);

        const selectResidues = ColormakerRegistry.addSelectionScheme(selectionScheme, "SCOP Domains");
        stage.loadFile("rcsb://"+pdbid).then(function(o) {
            o.addRepresentation("cartoon", {color: selectResidues });  // pass schemeId here        
            o.autoView();
        });  
    }

    componentDidMount() {
        const script = document.createElement("script");
        script.src = "https://cdn.rawgit.com/arose/ngl/v0.10.4-1/dist/ngl.js";
        script.async = true;
        document.body.appendChild(script);

        let pdbid = this.props.pdb_id;
        let selectedResidues = this.props.selectedResidues;
    
        var stage = new Stage("ngl");
        
      
        stage.setParameters({
            backgroundColor: "#F0F0F0"
        });
        this.setState({ngl: stage});

        let dhash = selectedResidues.reduce( (p, n) => {
            let chain = n[0];
            if (p[chain]) {
                p[chain].push(n[1] + '-' + n[2]);
            } else {
                p[chain] = [n[1] + '-' + n[2]];
            }
            return p;
        }, {});

      //  console.log(dhash);
       
        let selectionScheme = Object.keys(dhash).map( (k) => {
            return [colourMap["domain-scop"],  (':' + k + ' and ('+dhash[k].join(' or ') + ')')];
        });

    
        Object.keys(dhash).map( (k) => {
            return selectionScheme.push( [colourMap["domain-chain"],  (':' + k)]);
        });
        
        selectionScheme.push( [colourMap["domain-pdb"], "*"] );
      //  console.log("SS:", selectionScheme);

        const selectResidues = ColormakerRegistry.addSelectionScheme(selectionScheme, "SCOP Domains");
        stage.loadFile("rcsb://"+pdbid).then(function(o) {
            o.addRepresentation("cartoon", {color: selectResidues });  // pass schemeId here        
            o.autoView();
        });
        window.addEventListener( "resize", function( event ){ 
            stage.handleResize();
        }, false );
    }

    render() {
        return (<div id="ngl">
            <div className="ngl-colour-legend">
                <div> <span className="domain-scop"> &nbsp; </span> Domain only</div>
                <div> <span className="domain-chain"> &nbsp; </span> Domain in chain </div>
                <div> <span className="domain-pdb"> &nbsp; </span> Domain in PDB</div>
            </div>            
        </div>)
    }
}

class AncestryTree extends Component {
    constructor(props, context) {
        super(props, context);
        this.myRef = React.createRef();

        this.state = {
            termId: this.props.termId,
            isHidden: false,
            graph: {}
        };
    }

    componentDidMount() {
        const termId = this.props.termId;
        const url = [restServer, 'ancestry', termId].join("/");
        console.log('fetch: ', url);
        fetch(url)
        .then(response => response.json())
        .then(data => this.visualiseLineage(data.lineage, termId));
    }
   
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.termId !== this.props.termId) {
            this.setState({...this.state, isFetching: true});
            const termId =  nextProps.termId;
            const url = [restServer, 'ancestry', termId].join("/");
            console.log('fetch ', url);
            fetch(url)
            .then(response => response.json())
            .then(data => this.visualiseLineage(data.lineage, termId));
        }
    }
  
    visualiseLineage(lineage, termId) {
        if (!lineage) {
            return ;
        }
   
        const edgeDisplay = {
            'is': '[dir=both]',
            'partof' : '[dir=both;minlen=2]'
        };

        let graph_data = lineage.edges.map( (edge) => {
            return ('"'+lineage.nodes[edge[1]].id + '"->"' + lineage.nodes[edge[0]].id + '" ' + edgeDisplay[edge[2]])
        }).join(';');   
    //    console.log(lineage.nodes);
     //   console.log(termId);
        const currentNode =lineage.nodes[termId];
        let highlightNodes ='';
        if (currentNode) {
            const currentNodeName = lineage.nodes[termId].id;
            highlightNodes = '"' + currentNodeName + '" [ bgcolor="#555555" shape=rect style="rounded,filled" ] \n';
        }
       // console.log(graph_data);
      //1 [label="A"];
        const nodes = Object.keys(lineage.nodes).map( (nid) => {
            const node = lineage.nodes[nid];
            const node_url = process.env.PUBLIC_URL  + '/term/'+node.id;
            const node_label = node.type === 'domain' ? node.type + " " + node.id : node.type + " " + node.id + "\n" + node.name;

            return node.id + '[label="' + node_label + '" URL="' + node_url + '"]'; 
            } 
        ).join('; ');
       // console.log(nodes);

        let viz = new Viz({ Module, render });
        
     //   console.log(highlightNodes);
     //   console.log(graph_data);
     //   console.log(nodes);
        let parent = this.myRef.current;
        while (parent.firstChild) {
            parent.firstChild.remove();
        }

        viz.renderSVGElement('strict digraph { node [shape=rect style=rounded];' + nodes +  highlightNodes + graph_data + "}")
        .then( (element) => {
            element.removeAttribute('xmlns');
            element.removeAttribute('xmlns:xlink');
            element.setAttribute('preserveAspectRatio',"xMinYMin meet");
            element.setAttribute('width', '100%');
            //         element.setAttribute('height', '250px'); 
//            console.log(element);
            this.myRef.current.append(element);
        })
        .catch(error => {
          // Create a new Viz instance (@see Caveats page for more info)
          viz = new Viz({ Module, render });
      
          // Possibly display the error
          console.error(error);
        });    
    }

    toggleHidden () {
        this.setState({
          isHidden: !this.state.isHidden
        });

        if (this.state.isHidden) {
            this.myRef.current.setAttribute('class', 'invisible');
        } else {
            this.myRef.current.setAttribute('class', 'visible');
            logEvent('Show ancestry');     
        }
    }

    render() {

        return (
            <div className="ancestry-container">
                <div className="ancestry-checkbox">
                    <label htmlFor="show_ancestry">Show ancestry</label>
                    <input type="checkbox" name="show_ancestry" checked={this.state.isHidden} onChange={this.toggleHidden.bind(this)}/>
                </div>
                <div className="invisible" ref={this.myRef} id="ancestry"> </div>
            </div>
        )
    }
}
function TermInfo(props) {
    const tdata = props.tdata;

    return (
    <div id="term-panel">
        <div id="termheadline">
            <div className="ttype">{tdata.type}</div>
            { tdata.linkouts ? <TermLinkOuts links={tdata.linkouts} term_id={tdata.id} /> : ''}
        </div>
        <div id="termtitle">{tdata.name}</div>
        <div id="termid"><b>SCOP ID</b>: {tdata.id}</div>   
        <div id="terminfo">{tdata.description}</div>
        { tdata.protein_species ? <div id="pspecies"><span className="field-name-info">Species</span> <i>{tdata.protein_species}</i></div> : '' }
        { tdata.protein_function ? <div id="pfunction"><span className="field-name-info">Function</span> {tdata.protein_function}</div> : '' }
        { tdata.annotations ? tdata.annotations.map( (annos) => ( <Annotations key={annos.type} type={annos.type} items={annos.items} />)) : '' }
        { [3, 4, 8].includes(tdata.rank) ? <AncestryTree termId ={tdata.termId} /> : ''}
    </div>
    )
}

export default withRouter(Term, TermParents, Domains, StructureViewer, AncestryTree);


const LinkOuts = {
    'pfam' : "http://pfam.xfam.org/family/#ID#",
    'superfamily': "http://supfam.org/allcombs/#TID#"
}

function TermLinkOuts(props) {
    const tid = props.term_id;
    return (
        <div className="term-linkouts">
            { props.links.map( (link, index) => {
                const linkType = link.type; // pfam || superfamily
                const linkURL = LinkOuts[linkType].replace('#ID#', link.id).replace('#TID#', tid);

                return (
                    <a key={"tl_"+index} target="_ext_link" href={ linkURL }>
                        <img className="linkout" src={linkType === 'pfam' ? pfam : superfamily } alt="View {link.id} in {link.name}" />
                    </a>
                ) 
            })}
        </div>
    )
}

function TermDomain(props) { 
    let dtype = props.type;

    let urlUniProt = 'https://www.uniprot.org/uniprot/';
    let urlPDBe = 'https://www.ebi.ac.uk/pdbe/entry/pdb/';
    let urlRCSB = 'https://www.rcsb.org/structure/';
    let regions = props.parts;
        
    return (
        <div>
    <div className="td-container">
        <div className="td-protein-line">
            <span className="field-name">Protein</span>{props.name}
        </div>
        <div className="td-species-line">
            <div className="td-species-name">
            <span className="field-name">Species</span>{props.species}
            </div>
            <div className="td-protein-id">
                { props.uniprot ? 
                    <Link to={`${process.env.PUBLIC_URL}/search?t=uid;q=` + props.uniprot}>{props.uniprot}</Link>
                    : ' - '
                }
            </div>
            <div className="td-protein-region">
            {props.iparts}
            </div>
            <div className="td-protein-link">
                { props.uniprot ? 
                    <a alt="View in UniProt" target="ext_link" href={urlUniProt + props.uniprot}>UniProt <i className="fas fa-external-link-alt" area-hidden="true"></i></a>
                    : ' - '
                }
            </div>
         
        </div>
        <div className="td-rep-line">
            <div className="td-rep-name">
            <Link to={`${process.env.PUBLIC_URL}/term/`+props.id}>Representative {dtype} domain {props.id}</Link>
            <img src={viewer} alt="Structure Viewer" className="logo-viewer" onClick={() => showDomain(props.id)}/>
            { props.represents ? 
                <RepresentedStructures domain_id={props.id} cnum={props.represents}/>
                : ''
            }
            
            </div>
            <div className="td-protein-id">
            <Link to={`${process.env.PUBLIC_URL}/search?t=pdb;q=` + props.pdbid}>{props.pdbid}</Link>
            </div>
            <div className="td-protein-region">
            {regions}
            </div>
            <div className="td-protein-link">
                <a alt="View in PDBe" target="ext_link" href={urlPDBe + props.pdbid}>PDBe <i className="fas fa-external-link-alt" area-hidden="true"></i></a> <br/> 
                <a alt="View in RCSB PDB" target="ext_link" href={urlRCSB + props.pdbid}>RCSB PDB <i className="fas fa-external-link-alt" area-hidden="true"></i></a> 
            </div>

        </div>
    </div>
    </div>
    )
}

function ParentTerm(props) {
    return(
        <div className="pcontainer">
            <div className="parentterm">
            <span className="parenttype">{props.ptype}</span>
            <Link className="tlink" to={`${process.env.PUBLIC_URL}/term/`+props.termid}>{props.name}</Link>
            </div>
            { props.ptid ? 
            <div className='ptype'>
            <b>PROTEIN TYPE</b>
            <Link className="tlink" to={`${process.env.PUBLIC_URL}/term/`+props.ptid}>{props.ptname}</Link>
            </div>
            : ''
            }  
        </div>
    )
}

const type2title = {
    'fold' : 'Folds',
    'iupr' : 'IUPRs',
    'superfamily': 'Superfamilies',
    'family' : 'Families',
    'alsoShared' : "Also shared by families"
}

function TermChildren(props) {
    const items = props.children;
    const inum = items.length;
    const sw = type2title[props.type] || "Descendants";
   
    return (
        <div id="termchildren" className="panel-children">
            <div className="panel-title">{sw} <span className="title-note">[ {inum} { inum > 1 ? "entries" : "entry "} ]</span></div>
            {items.map((item, index) => (
                <ChildTerm key={"ch_"+item.id} termid={item.id} name={item.name} info={item.description} cnum={item.cnum} type={props.type} domain={item.domain}/>
            ))}
        </div>
    )
}

class Annotation extends Component {
    render() {
        const tip = this.props.tip ? this.props.tip : '';
        if (tip) {
            return (
                <OverlayTrigger key={this.props.idx} placement="bottom" className="mytooltip"
                    overlay={
                        <Tooltip className="mytooltip" id={`tooltip-${this.props.idx}`} >
                        {tip}
                        </Tooltip>
                    }
                >
                    <div className="relation">        
                        <Link className="slink" to={`${process.env.PUBLIC_URL}/search?t=`+this.props.type+";q="+this.props.name}>{this.props.name}</Link>
                    </div>
                </OverlayTrigger>

            )
        } else {
            return (
            <div className="relation">        
                {this.props.name}
            </div>
            )
        }
    }
}

function Annotations(props) {
    const items = props.items;
    const label = props.type;
    return (
        <div className="term-annotations">
            <span className="annotations-type">
                {label}
            </span>
            {
                items.map((item, index) => (
                    <Annotation key={props.type+index} idx={index} name={item.name} tip={item.description} type={props.type}/>
                ))
            }
        </div>
    );
}

function showDomain(domain_id) {
    //https://developer.mozilla.org/en-US/docs/Web/API/Window/open
    const strWindowFeatures = "width=600,height=600,menubar=no,titlebar=no,location=no,resizable=yes,scrollbars=yes,status=no";
    const url = process.env.PUBLIC_URL + '/sview/' + domain_id;
    window.open(url,'_blank', strWindowFeatures);
}


function ChildTerm(props) {
    return (
        <div className="child-container">
            <div className="term-name-with-id">
                <div className="termlink"> <Link to={`${process.env.PUBLIC_URL}/term/`+props.termid}>{props.name}</Link> </div>
                <span className="spacer-fold">SCOP ID {props.termid}
                { props.domain ?  <img src={viewer} alt="Structure Viewer" onClick={() => showDomain(props.domain)} className="logo-viewer"/>
                 : '' }
                </span> 
                 
            </div>
            <div className="childdesc">{props.info}</div>
            { props.cnum > 0 ? 
                <GrandChildren termid={props.termid} num={props.cnum} type={props.type}/>
                : ''
            }
        </div>
    )
}

const type2descendants = {
    'fold' : 'Superfamilies',
    'iupr' : 'Superfamilies',
    'superfamily' : 'Families'
}

class GrandChildren extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: true,
            isFetching : false,
            isInitialised: false,
            props: props,
            data: {}
        };

    } 

    toggleCollapsed() {
        if (!this.state.isInitialised) {
            this.fetchInfo(this.state.props.termid)
        } else {
            this.setState({ isCollapsed: !this.state.isCollapsed });
        }
        if (this.state.isCollapsed) {
            logEvent('Expand children');
        }
    }

    fetchInfo = (termId) => {
        if (isStaticSite) {
            let tdata = fetchTerm(termId);
            tdata.termId = termId;
            this.setState({data: tdata});
        } else {
            this.setState({...this.state, isFetching: true});
            const url = [restServer, 'children', termId].join("/");
      //      console.log(' fetch ', url);
            fetch(url)
                .then(response => response.json())
                .then(data =>  this.setState({ data: data, isFetching: false, isInitialised: true, isCollapsed: false }))
                .catch( e=> console.log(e));
        }
    }
    componentDidMount() {
       // this.fetchInfo(this.state.props.termid);
    } 
  
    render(props) {
        if (! this.state.data) {
            return ('')
        } 

       // console.log(this.state.data);
        const items = this.state.data.children;
        const type = this.props.type;
        const descendantsType = type2descendants[type] || "UNKNOWN:"+type;

        if (! ['fold','superfamily','iupr'].includes(type)) {
            return (<div></div>);
        }
       
        return (
            <div className="grandchildren-container">
                <div className="descendants">{descendantsType}: {this.props.num}</div>
                <div className="icon" onClick={this.toggleCollapsed.bind(this)}>
                    { this.state.isCollapsed ? 
                    <i className='fas fa-folder-plus'></i> :
                    <i className='fas fa-folder-minus'></i>
                    }
                </div>

                { this.state.isCollapsed ? 
                  '' :
                <div className="grandchildrenlist">
                    <hr></hr>
                    {items.map((item,index) => 
                    (<div key={"gc_"+item.id} className="termlink">
                        <Link to={`${process.env.PUBLIC_URL}/term/`+item.id}>{item.name}</Link>
                        <span className="sp">SCOP ID {item.id}</span>
                        <img src={viewer} onClick={() => showDomain(item.domain)} alt="Structure Viewer" className="logo-viewer2"/> 
                    </div>))}
                </div>
                }
            </div>
        )
    }
}


class RepresentedStructures extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: true,
            isFetching : false,
            isInitialised: false,
            props: props,
            data: {}
        };
    } 

    toggleCollapsed() {
        if (!this.state.isInitialised) {
            this.fetchInfo(this.state.props.domain_id)
        } else {
            this.setState({ isCollapsed: !this.state.isCollapsed });
        }
        if (this.state.isCollapsed) {
            logEvent('Expand structures');
        }
    }

    fetchInfo = (termId) => {
        if (isStaticSite) {
            let tdata = fetchTerm(termId);
            tdata.termId = termId;
            this.setState({data: tdata});
        } else {
            this.setState({...this.state, isFetching: true});
            const url = [restServer, 'represented_structures', termId].join("/");
          //  console.log(' fetch me', url);
            fetch(url)
                .then(response => response.json())
                .then(data =>  this.setState({ data: data, isFetching: false, isInitialised: true, isCollapsed: false }))
                .catch( e=> console.log(e));
        }
    }
    
    render(props) {
        if (! this.state.data) {
            return ('')
        } 

      //  console.log(this.state.data);

        let items = this.state.data.represented || [];
       // let num = this.state.isInitialised ? items.length : "?";
        //console.log(items);
        const num = this.state.props.cnum;

        return (

            <div className="nonreps-container">
                <div className="descendants">Represented structures [ { num } ]</div>
                <div className="icon" 
                onClick={this.toggleCollapsed.bind(this)}
                >
                    { this.state.isCollapsed ? 
                    <i className='fas fa-folder-plus'></i> :
                    <i className='fas fa-folder-minus'></i>
                    }
                </div>

                { this.state.isCollapsed ? 
                  '' :
                
                <div className="grandchildrenlist">
                    <hr></hr>
                    {items.map((item,index) => 
                    (<div key={"nr_"+index}>
                        {item.pdb_id + " " + item.chain}
                    </div>))}
                </div>
                }
        
            </div>
        )
    }
}


/* this is also in Term.css */
const colourMap = {
    "domain-scop"   : "#E59749",
    "domain-pdb"    : "white",
    "domain-chain"  : "skyblue",
    "uniprot"       : '#3666D1',
    "domain-sf"     : '#6B8E23',
    "domain-fa"     : '#53B8B1',
    "domain-cf"     : 'skyblue',
    "domain-hf"     : 'salmon'
} ;

class Representative extends Component{
    constructor(props) {
        super(props);
        this.state = {
            domains: []
        }
    }

    componentDidMount() {
        const UniProtId = this.props.uniprot_id;
        if (isStaticSite) {
            const terms = fetchSearch(UniProtId, 'd', 'uniprot');
            this.setState({ domains: terms})
        } else {
            const url = [restServer, 'domains_by_uniprot', UniProtId].join("/");
          /*
            const params = {
                q: UniProtId,
                t: 'uniprot',
                o: 'd'
            };
            */
            fetch(url)
            .then(response => response.json())
            .then(data => this.setState({domains: data.domains}));
        }
    }

    render () {
        const external_links = [
        {
            section: 'More information about #PDBID# in other resources',
            links: [
                { name: "PDBe", url: 'https://www.ebi.ac.uk/pdbe/entry/pdb/#PDBID#' },
                { name: "RCSB PDB", url: 'https://www.rcsb.org/structure/#PDBID#' },
                { name: "UniProt", url: 'https://www.uniprot.org/uniprot/#UNIPROTID#' },
      
                { name: "CATH", url: 'http://www.cathdb.info/search?q=#PDBID#' },
                { name: "ECOD", url: 'http://prodata.swmed.edu/ecod/complete/search?kw=#PDBID#&type=pdbid' },
                { name: "PDBe-PISA", url: "http://www.ebi.ac.uk/pdbe/pisa/cgi-bin/piserver?qs=#PDBID#" },
                { name: "PDBe-KB", url: "https://www.ebi.ac.uk/pdbe/pdbe-kb/proteins/#UNIPROTID#"},
                { name: 'Protein Contacts Atlas', url: 'https://www.mrc-lmb.cam.ac.uk/pca'}
            ]
        },
        { 
            section: 'Compare/search for structures similar to #PDBID#',
            links: [
                { name: 'DALI', url: 'http://ekhidna2.biocenter.helsinki.fi/dali'}, 
                { name: 'TOPMATCH', url: 'https://topmatch.services.came.sbg.ac.at/'},
                { name: 'FATCAT', url: 'http://fatcat.sanfordburnham.org/'},
                { name: 'PDBeFOLD', url: 'http://www.ebi.ac.uk/msd-srv/ssm'}
            ]
        }
        ];
        const PDBId = this.props.pdb_id;
        const UniProtId = this.props.uniprot_id;
        
        const sections = external_links.map ( (els, index) => {
        let section_items = els.links.map( (item) =>  { 
            let u = item.url.replace('#PDBID#', PDBId).replace('#UNIPROTID#', UniProtId);
            return { name: item.name, url: u };
        });

        return {
            title: els.section.replace('#PDBID#', PDBId),
            items: section_items
        }
        });

        const seqlen = this.props.sequence.length;
        const main_items = [
            { x:1, y:0, w:seqlen, color: colourMap.uniprot } // UniProt Sequence
        ]
        let row_height = Math.floor(seqlen / 100) + 5; 
        let row_gap = 2;

        if (seqlen > 600) {
            row_gap = 3;
        }
        if (seqlen > 1000) {
            row_gap = Math.floor(seqlen / 200);
            row_height = Math.floor(seqlen / 90) + 5; 
        }
        if (seqlen > 1000) {
            row_gap = Math.floor(seqlen / 100);
            row_height = Math.floor(seqlen / 70); 
        }
      
        if (seqlen < 500) {
            row_height = 7;
        }
        if (seqlen < 400) {
            row_height = 6;
            row_gap = 1.5;
        }
        if (seqlen < 340) {
            row_height = 4.3;
        }
        if (seqlen < 280) {
            row_height = 3.5;
            row_gap = 0.8;
        }
        if (seqlen < 220) {
            row_height = 3;
        }
        if (seqlen < 180) {
            row_height = 2.5;
        }
        if (seqlen < 150) {
            row_height = 2;
        }
        if (seqlen < 120) {
            row_height = 1.5;
            row_gap = 0.5;
        }
        if (seqlen < 80) {
            row_height = 1;
            row_gap = 0.5;
        }
       
        if (seqlen < 40) { // 8025732 ( 30aa )
            row_height = 0.7;
            row_gap = 0.2;
        }
       
        //const row_height = 4;
      //  console.log("SEGMENTS:", this.props.segments);

        // This domain
        this.props.segments.map( (s, index) => {
            main_items.push({ x: s[0], y: row_height + row_gap, w: s[1]-s[0]+1, color: colourMap["domain-scop"]});
            return index;
        })

        const other_domains = this.state.domains || [];
     //   console.log("OD: ", other_domains);
     //   console.log(seqlen, ' : ', row_height);

        const other_items = [];
        const other_names = [];

        let index = 0;
        for (let domain_id in other_domains) {
            if (domain_id === this.props.termId) {
                continue;
            }
           // console.log(other_domains[domain_id]);
            let y = index * row_height + index * row_gap + (row_height + row_gap )*2;
            const c = colourMap["domain-"+other_domains[domain_id].type.toLowerCase()];
        //    console.log( other_domains[domain_id].protein_segments );

            other_domains[domain_id].protein_segments.map((s) => {
                other_items.push({ x: s[0], y: y , w: s[1]-s[0]+1, color: c });
                return 0;
            });

            let ddhash  = other_domains[domain_id].pdb_segments.reduce( (p,n) => {
      //          console.log(n);
                let chain = n[0];
                if (p[chain]) {
                    p[chain].push(n[1] + '-' + n[2]);
                } else {
                    p[chain] = [n[1] + '-' + n[2]];
                }
                return p;
            }, {});

            let dname = Object.keys(ddhash).map( (k) => {
                return (' ' +k+':'+ddhash[k].join(','))  
            }).join(',');

            if (dname.length > 20) {
                dname = dname.substr(0,17) + '...';
            }
            other_names.push({id: domain_id, name: other_domains[domain_id].pdb_code + dname});
            index ++;
        }
//        console.log("ON::", other_names);
/*
        other_domains.map( (item, index) => {
            const y = index * row_height + 20;
            const c = colourMap["domain-"+item.type];

            item.protein_segments.map((s) => {
                other_items.push({ x: s[0], y: y, w: s[1]-s[0]+1, color: c });
                return 0;
            });
            return 0;
        });
  */
 //       console.log("seqlen:", seqlen);
 //       console.log("row_height:", row_height);

        const viewbox = [0, 0, seqlen + 1, (row_height + row_gap + 2)  * 2].join(" ");
        const other_viewbox = [0, 0, seqlen + 1, ( other_names.length + 2) * (row_height + row_gap + 2)  ].join(" ");

        return(
            <div className="representative">
                <Tabs className="myClass" defaultActiveKey="seqtab" id="seqtab">
                    <Tab eventKey="seqtab" title="Representative sequence">
                    
                        <div className="sequence">
                            <div id="graphics">
                                <div className="gr_other">
                                    <div className="legend">
                                        <div className="gname2">
                                            { UniProtId ? 
                                                "UniProt" + UniProtId 
                                                : "Sequence"
                                            }
                                        </div>
                                        <div className="gname2">This domain</div>
                                        <div className="gname2">&nbsp;</div>
                                    </div>
                                
                                    <div className="svg-container">
                                        <svg viewBox={viewbox} className="svg-content">
                                        {
                                            main_items.map((item, index) => ( <DomainSVGBox key={"g_"+item.x + "-" + item.w + ':' + item.y} item={item} row_height={row_height}/> ))
                                        }
                                        </svg> 
                                    </div>
                                </div>
                            </div>
                            <MarkedUpSequence sequence={this.props.sequence} segments={this.props.segments} />
                        </div>
                    </Tab>
                    <Tab eventKey="otherdomain" title="Other domains for this sequence">
                        <div className="sequence">
                            <div id="graphics2">
                                <div className="gr_other">
                                    <div className="legend">
                                    <div className="gname2">UniProt {UniProtId}</div>
                                    <div className="gname2">This domain</div>
                                    {
                                        other_names.map( (item, index) => {
                                            return (
                                                <div key={index + "_" + item.id} className="gname2"><Link to={`${process.env.PUBLIC_URL}/term/`+item.id}>{item.name}</Link></div>
        
                                            )
                                        })
                                    }
                                    <div className="gname2">&nbsp;</div>
                                </div>
                                    <div className="svg-container">
                                        <svg viewBox={other_viewbox}  className="svg-content">
                                        {
                                            main_items.map((item, index) => ( <DomainSVGBox key={"g_"+item.x + "-" + item.w + ':' + item.y} item={item} row_height={row_height} /> ))
                                        }
                                        {
                                            other_items.map((item, index) => ( <DomainSVGBox key={"g_"+item.x + "-" + item.w + ':' + item.y} item={item} row_height={row_height}/> ))
                                        }
                                        </svg> 
                                    </div>
                                
                                </div>
                                <div className="domain-color-legend">
                                    <div className="gname2">
                                        <span className="domain-sf"> &nbsp; </span> Superfamily domain
                                    </div>
                                    <div className="gname2">
                                        <span className="domain-fa"> &nbsp; </span> Family domain
                                    </div>                       
                                </div> 
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="extlinks" title="External links">
                        <div className="extlinks-div">
                        {
                            sections.map( (s) => ( <DomainExternalLinksSection key={s.title} name={s.title} items={s.items} />))
                        }
                        </div>
                    </Tab>
                </Tabs>
            </div>
        )

    }
}

function MarkedUpSequence(props) {
    let markup = props.sequence.replace(/(.{10})/g, '$1 ');
    console.log(markup);

    let mtype = 0; // base type

    const positions = props.segments.map((s) => { return [s[0]-1, s[0], s[1], s[1]+1]; }).flat();
  //  console.log(positions);

    if (positions[0] < 1) {
        positions.shift();
        mtype = !mtype;
    } else {
        positions.unshift(1);
    }

    if (positions[-1] > props.sequence.length) {
        positions.pop();
    } else {
        positions.push(props.sequence.length);
    }

  //  console.log(positions);


    const segments = positions.map( (e, index, arr) => {
        if (index % 2 === 1) {
           let s = arr[index -1 ]; 
        //   console.log('segment:', s, e);

           let start = s + Math.floor(s/10) -1;
           if (s % 10 === 0) {
               start = start - 1;
           }
           let end = e + Math.floor(e/10) ;
          
        //   console.log('start = ', start);
        //   console.log('end = ', end);


           const txt = markup.substring(start, end);
        //   console.log(txt);
           mtype = !mtype;
           return {type: mtype ? 'base' : 'scop', txt: txt};          
        }
        return '';
    });

  //  console.log(segments);
  //  console.log(markup);

    return (<div className="markedup-container">
        { 
            segments.map( (s, index) => (
                <span key={index} className={s.type}>{s.txt}</span>
            ))
        }
    </div>);
}

function DomainSVGBox(props) {
    const item = props.item;
    const rh = props.row_height || 7;
    const rx = rh - 2 || 1;

    return (
        <g>
            <rect className="dbar" x={item.x} y={item.y} width={item.w} height={rh} rx={rx} fill={item.color} />
        </g>
    )
    /*
    return (
        <g>
            <rect className="dbar" x={item.x} y={item.y} width={item.w} height="7" rx="5" fill={item.color} />
            <text className="dtext" x={item.x +2} y={item.y+6}>{item.w +'a'}</text>
        </g>
    )
    */
}

function DomainExternalLinksSection(props) {
    const title = props.name;
    const items = props.items;

    return (
        <div className="domain-extlinks-section">
            <div className="domain-extlinks-section-title">{title}</div>
            {   
                items.map((item) => (
                    <DomainExternalLink key={item.name} url={item.url} name={item.name} />
                ))
            }
        </div>
    ) 
}

function DomainExternalLink(props) {
    return (
        <div className="domain-extlink-item">
            <a target="_ext_link" href={props.url}>{props.name}</a> 
            <i className="fas fa-external-link-alt" area-hidden="true"></i>
        </div>
    )
}
